import { render, staticRenderFns } from "./CamaraHistorico.vue?vue&type=template&id=32fecaa1&scoped=true&"
import script from "./CamaraHistorico.vue?vue&type=script&lang=ts&"
export * from "./CamaraHistorico.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraHistorico.vue?vue&type=style&index=0&id=32fecaa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fecaa1",
  null
  
)

export default component.exports